module.exports = __webpack_public_path__ + "img/style_3_3.07ed1ea0.png";